import ReactDragListView from './ReactDragListView';
import ReactDragColumnView from './ReactDragColumnView';

ReactDragListView.DragColumn = ReactDragColumnView;
export default ReactDragListView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-drag-listview/es/index.js
// module id = 4675
// module chunks = 0